import { render } from "./accessibility_areas.vue?vue&type=template&id=9c182344"
import script from "./accessibility_areas.vue?vue&type=script&lang=js"
export * from "./accessibility_areas.vue?vue&type=script&lang=js"

import exportComponent from "/opt/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__